import * as yup from "yup";























/**
 * Schema exports four Yup validation schemas, which are
 * used to validate forms in the application.
 *
 * The exported schemas are:
 *
 * - `RSVPSearchQueryFormSchema`: Used to validate the search query form.
 * - `paystackFormSchema`: Used to validate the Paystack payment form.
 * - `eventRsvpFormSchema`: Used to validate the event RSVP form.
 * - `resumeClinicRsvpFormSchema`: Used to validate the resume clinic RSVP form.
 *
 * Each schema defines the validation rules for its respective form.
 */
export const Schema = () => {
  const paystackFormSchema = yup.object().shape({
    firstName: yup
      .string()
      .trim("Cannot be empty space")
      .required("First name is required."),
    lastName: yup
      .string()
      .trim("Cannot be empty space")
      .required("Last name is required."),
    email: yup
      .string()
      .trim("Cannot be empty space")
      .email("Must be a valid email")
      .required("Email is required."),
    amount: yup
      .string()
      .trim("Cannot be empty space")
      .required("Amount is required"),
  });

  const eventRsvpFormSchema = yup.object().shape({
    name: yup
      .string()
      .trim("Cannot be empty space")
      .required("First name is required."),
    email: yup
      .string()
      .trim("Cannot be empty space")
      .email("Must be a valid email")
      .required("Email is required."),
    ageRange: yup.mixed().required("Age range is required.").nullable(),
    gender: yup.mixed().required("Gender is required.").nullable(),
    educationalQualification: yup.mixed().nullable(),
    employmentStatus: yup.mixed().nullable(),
    digitalLiteracyLevel: yup.mixed().nullable(),
    technicalSkills: yup.mixed().nullable(),
    currentDeviceUsed: yup.mixed().required("Device is required.").nullable(),
    digitalTraining: yup.mixed().nullable(),
    internShipTraining: yup.mixed().nullable(),
    adoptSkill: yup.mixed().nullable().required("Skill is required."),
  });

  const RSVPSearchQueryFormSchema = yup.object().shape({
    query: yup.string(),
  });


  const resumeClinicRsvpFormSchema = yup.object().shape({
    fullName: yup
      .string()
      .trim("Cannot be empty space")
      .required("Full name is required."),
    email: yup
      .string()
      .trim("Cannot be empty space")
      .email("Must be a valid email")
      .required("Email is required."),
    phoneNumber: yup
      .string()
      .trim("Cannot be empty space")
      .required("Phone number is required."),
    positionInterested: yup.mixed().nullable(),
    gender: yup.mixed().required("Gender is required.").nullable(),
    educationalQualification: yup.mixed().nullable(),
    employmentStatus: yup.mixed().nullable(),
    eventDate: yup.mixed().nullable(),
    jobSearchStatus: yup.mixed().nullable(),
  });

  const resumeCohortFormSchema = yup.object().shape({
    cohortMonth: yup.string(),
  });
  return {
    RSVPSearchQueryFormSchema,
    paystackFormSchema,
    eventRsvpFormSchema,
    resumeClinicRsvpFormSchema,resumeCohortFormSchema
  };
};
